import './style.css';
import Cards from '../../componentes/cards/card';
const sobre=()=>{
    return (
        <div className='container div'>
            <h1 className='margem'>Sobre</h1>
            <p>Maio de 2021, inaugura-se a Padaria e Mercearia Mix, uma empresa genuinamente mineira, com a finalidade de se tornar um ponto de encontro dos moradores de Santa Luzia.
 
 Como missão, a Padaria e Mercearia Mix pretende oferecer, além de diversos itens da culinária mineira, qualidade nos produtos, cordialidade, inovação, excelência no atendimento, ambiente agradável, conforto e segurança, de modo a superar as expectativas dos clientes.
  
 Vislumbramos ser, a curto prazo, não só em Santa Luzia, como em todo o Estado de Minas Gerais, líder no segmento de panificação, confeitaria e lanches rápidos, com a solidificação da marca na Capital e expansão para diversos municípios do Estado, sendo também uma empresa reconhecida pelos níveis de excelência em sua atuação empresarial.</p>
            
                
            
 <iframe className='video' width="1280" height="720" src="https://www.youtube.com/embed/-5gMeHkDTGY" title="Incríveis Máquinas para Fabricação e Processamento de Pães - Linha de produção automatizada de pães" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        
       </div>
    )
}
export default sobre;